import {
  addBroadcastEventsListener,
  broadcastLogInEvent,
  broadcastLogOutEvent,
  removeBroadcastEventsListener,
} from './actions';
import { AuthModel } from './AuthMachine.model';

export const AuthMachine = AuthModel.createMachine(
  {
    context: AuthModel.initialContext,
    id: 'auth-machine',
    initial: 'idle',
    states: {
      idle: {
        on: {
          INIT_GUEST_SESSION: {
            target: '#auth-machine.session.loggedOut',
            actions: 'saveCsrfTokenToStorage',
          },
          INIT_LOGGED_IN_SESSION: {
            target: '#auth-machine.session.loggedIn',
            actions: 'saveCsrfTokenToStorage',
          },
        },
      },
      session: {
        states: {
          loggedOut: {
            on: {
              LOGIN: {
                target: 'loggedIn',
                actions: ['saveCsrfTokenToStorage', 'broadcastLogInEvent'],
              },
            },
          },
          loggedIn: {
            on: {
              LOGOUT: {
                target: 'loggedOut',
                actions: ['saveCsrfTokenToStorage', 'broadcastLogOutEvent'],
              },
            },
          },
        },
      },
    },
    entry: 'addBroadcastEventsListener',
    exit: 'removeBroadcastEventsListener',
    on: {
      UPDATE_CSRF_TOKEN: {
        actions: 'saveCsrfTokenToStorage',
      },
    },
  },
  {
    actions: {
      broadcastLogInEvent,
      broadcastLogOutEvent,
      addBroadcastEventsListener,
      removeBroadcastEventsListener,
    },
  },
);
